import React from "react";
import { SVG, IconProps } from "../SVG";
export const SpotCross = ({
    spotColor = "#C9DBFE",
    color = "#13126C",
    strokeWidth = "2.2",
    ...props
}: IconProps) => (
    <SVG xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 40 40" {...props}>
        <path
            fill={spotColor}
            d="M34.4 39.076c-6.746 2.775-12.172-1.247-18.456-4.857C9.534 30.002-.79 31.317.048 22.86c.665-6.725 8.407-7.027 14.496-11.029C20.6 7.835 23.221 5.904 28.44 7.638c5.183 1.739 10.16 5.108 11.292 11.247 1.098 6.143-1.28 17.657-5.332 20.19Z"
        />
        <path
            stroke={color}
            strokeLinejoin="round"
            strokeWidth={strokeWidth}
            d="M26.12 2H13.379v11.378H2v12.744h11.378V37.5H26.12V26.122h11.378V13.378H26.12V2Z"
        />
    </SVG>
);
SpotCross.displayName = "SpotCross";
